import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {SuccessMessageComponent, SuccessMessageData} from '../../components/success-message.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  showSuccess(config: Omit<SuccessMessageData, 'type'>): void {
    this.showMessage({
      ...config,
      type: 'success'
    });
  }

  showInfo(config: Omit<SuccessMessageData, 'type'>): void {
    this.showMessage({
      ...config,
      type: 'info'
    });
  }

  showWarning(config: Omit<SuccessMessageData, 'type'>): void {
    this.showMessage({
      ...config,
      type: 'warning'
    });
  }

  showError(config: Omit<SuccessMessageData, 'type'>): void {
    this.showMessage({
      ...config,
      type: 'error'
    });
  }

  private showMessage(config: SuccessMessageData): void {
    this.snackBar.openFromComponent(SuccessMessageComponent, {
      data: config,
      duration: config.duration || 5000,
      horizontalPosition: 'center', // Changé à center
      verticalPosition: 'bottom',   // Changé à bottom
      panelClass: ['custom-snackbar']
    });
  }
}